import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/place-categories')({
  staticData: { breadcrumb: 'Категории мест' },
  component: () => <Outlet />,
});
